import z from 'zod';

export const createProjectSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, 'Project name must be at least 3 characters.')
    .max(80, 'Project name must be 80 characters or less.'),
  durationDays: z.coerce
    .number()
    .int('Duration must be a whole number.')
    .min(1, 'Duration must be at least 1 day.')
    .max(3650, 'Duration looks too large (max 3650 days).'),
});

export type CreateProjectFormValues = z.infer<typeof createProjectSchema>;
